import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MojoPrivilegesModule } from 'mojo-privileges';

import { CandidateBadgesPopoverComponent } from './components/candidate-badges-popover/candidate-badges-popover.component';
import { CandidateBadgesComponent } from './components/candidate-badges/candidate-badges.component';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';

@NgModule({
  declarations: [CandidateBadgesComponent, CandidateBadgesPopoverComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MojoPrivilegesModule,
    MatMenuModule,
    MojoFeatureExtensionsModule,
  ],
  exports: [CandidateBadgesComponent, CandidateBadgesPopoverComponent],
})
export class BadgesModule {}
